import React, { useRef } from 'react'
import { Drawer } from 'antd'
import Icon from 'meinian-package/src/component/icon'
import { Empty } from 'meinian-package/src/baseComponent'
import { sampleHasAuth } from 'meinian-package/src/utils/auth'
import CreateFile from '../createFile/index'
import FileCard from '../fileCard'
import { useSetTop, useUnsetTop } from '../../hooks/useTop'
import styles from './index.module.less'

export default ({ visible, data, totalCount, query,
  onUpdate, info, onClose, onInit, }) => {
  const $list = useRef(null)
  const onSetTop = useSetTop(onInit)
  const onUnsetTop = useUnsetTop(onInit)
  const _onClick = (topFlag, item) => {
    if (topFlag !== 1) {
      onSetTop(item.id)
    } else {
      onUnsetTop(item.id)
    }
  }

  return <Drawer
    closable={false}
    width={480}
    placement="right"
    onClose={onClose}
    visible={visible}
    className={styles['mn-drawer']}
  >
    <div className="mn-drawer-header">
      <div style={{ display: 'flex' }}>
        <div className="title">全部文件夹</div>
        <div className="info">数量<span style={{ marginLeft: '4px' }}>{totalCount}</span></div>
      </div>

      <div className="close" onClick={onClose}>
        <Icon type="m-guanbi" className="mn-drawer-header-close" />
      </div>
    </div>

    <div className="mn-drawer-content" ref={$list}>
      <span>
        {
          sampleHasAuth('createAndUpdateFolder') && <CreateFile info={info} style={{ width: '320px' }} onClick={() => onInit()} />
        }
        {data?.map(item => <div className="mn-drawer-content-list-item-wrap" key={item.id}>
          <div className="mn-drawer-content-list-item">
            <FileCard
              query={query}
              style={{ width: '320px' }}
              data={item}
              titleWidth={192}
              onLink={onClose}
              onInit={() => { onInit?.() }}
              onCancelTop={() => onUnsetTop(item.id)}
              onTop={() => onSetTop(item.id)}
              onUpdate={onUpdate}
            />
            <div
              className="mn-drawer-content-list-item-top"
              onClick={(e) => _onClick(item.topFlag, item, e)}
            >{item.topFlag ? '取消置顶' : '置顶'}</div>
          </div>
        </div>) ?? <Empty title="暂无相关文件夹" type="folder" />}
      </span>
    </div>
  </Drawer>
}
